import { CanDeactivateFn } from '@angular/router';

/** Contract implemented by a live assessment player that can safely approve route exit. */
export interface AssessmentAttemptExitAware {
  canDeactivateAssessment(): boolean | Promise<boolean>;
}

/** Keeps route changes inside Angular on the same save-integrity path as explicit exit. */
export const assessmentAttemptExitGuard: CanDeactivateFn<AssessmentAttemptExitAware> =
  (component) => component.canDeactivateAssessment();
